import type { HasMenuId, HasVisible } from '../../types';
import { getMenuIds } from '../get-menu-ids';
import { partitionByVisible } from '../partition-by-visible';

// Split and map items into two new arrays, the first containing visible menu ids and the second containing hidden menu ids
export const getMenuIdsByVisible = <T extends HasMenuId & HasVisible>(items: T[]) =>
	partitionByVisible(items).map(getMenuIds) as [string[], string[]];
